import {Injectable} from '@angular/core';
import {AngularFireDatabase} from "@angular/fire/database";
import {Observable} from "rxjs";
import {Field} from "./field";

@Injectable()
export class FieldsService {

  static fieldsPath: string = "/fields/";

  constructor(private db: AngularFireDatabase) {
  }

  addField(clubId: string, name: string, description: string, type: string) {
    let field = {
      "name": name,
      "description": description,
      "type": type,
      "soll": -1,
      "isOverboosted": false
    };

    const fields = this.db.list(FieldsService.fieldsPath + clubId);
    let key = fields.push(field);
    //console.log('Field key: ' + key);
  }

  delete(dbPath: string) {
    const itemRef = this.db.object(FieldsService.fieldsPath + dbPath);
    //console.log("Deleting " + FieldsService.fieldsPath + dbPath);
    itemRef.remove();
  }

  updateField(clubId: string, fieldId: string, name: string, description: string, type: string) {
    let field = {
      "name": name,
      "description": description,
      "type": type
    };

    this.db.object(FieldsService.fieldsPath + clubId + '/' + fieldId).update(field);
  }

  updateFieldIst(clubId: string, fieldId: string, ist: number) {
    let field = {
      "ist": ist
    };
    this.db.object(FieldsService.fieldsPath + clubId + '/' + fieldId).update(field);
  }

  updateFieldOverboost(clubId: string, fieldId: string, isOverboosted: boolean) {
    let field = {
      "isOverboosted": isOverboosted
    };
    this.db.object(FieldsService.fieldsPath + clubId + '/' + fieldId).update(field);
  }

  updateFieldSoll(clubId: string, fieldId: string, soll: number) {
    let field = {
      "soll": soll
    };
    this.db.object(FieldsService.fieldsPath + clubId + '/' + fieldId).update(field);
  }

  // NOT USED
  findAllFields(): Observable<Field[]> {
    return this.db.list(FieldsService.fieldsPath).valueChanges().map(Field.fromJsonArray);
  }

  findFieldsForClubId(id: string): Observable<Field[]> {
    // return this.db.list(FieldsService.fieldsPath + id).valueChanges().map(Field.fromJsonArray)
    return this.db.list(FieldsService.fieldsPath + id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(action => {
          const $key = action.payload.key;
          return Field.toField({ $key, ...action.payload.val() });
        })
      })
  }

  findFieldForClubIdAndFieldId(clubId: string, fieldId: string): Observable<Field> {
    //return this.db.object(FieldsService.fieldsPath + clubId + '/' + fieldId).valueChanges().map(Field.fromJson)
    return this.db.object(FieldsService.fieldsPath + clubId + '/' + fieldId)
      .snapshotChanges()
      .map(action => {
          const $key = action.payload.key;
          return Field.toField({ $key, ...action.payload.val() });
        })
  }

}
